import ibanLib from "iban";
import { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../utils/hooks/useActionCallback";
import { PatchAddBorrowerCashInCashOutMethod } from "../../../../../utils/mappers/PatchAddBorrowerCashInCashOutMethod";
import { PatchSetBorrowerCashInCashOutMethodToLoan } from "../../../../../utils/mappers/PatchSetBorrowerCashInCashOutMethodToLoan";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";
import { DECLARED_INCOME } from "../../DeclaredIncome/config";

export const useSetBankAccountDetails = () => {
  const {
    state: { loan, participant },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = useState({
    currentStepGroupStep: DECLARED_INCOME.SET_BANK_ACCOUNT,
    values: {},
    formSubmitSuccess: false,
    bankAccountIBAN: loan.borrower_cash_in_cash_out_method_account_number,
    cashInCashOutMethodId: null,
  });

  const { values, formSubmitSuccess, bankAccountIBAN } = state;

  const onSubmitModule = (values) => {
    const bankAccountIBAN = values?.bankAccountIBAN
      ? ibanLib.electronicFormat(values.bankAccountIBAN)
      : undefined;

    setState((s) => ({ ...s, bankAccountIBAN, values }));
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
      },
    });
    processPatchAddBorrowerCashInCashOutMethod(bankAccountIBAN, values.type);
  };

  const processPatchAddBorrowerCashInCashOutMethod = (
    bankAccountIBAN,
    type
  ) => {
    const cashInCashOutMethodId = uuidv4();

    setState((s) => ({
      ...s,
      cashInCashOutMethodId: cashInCashOutMethodId,
    }));

    const allDataToPatch = PatchAddBorrowerCashInCashOutMethod.dehydrate({
      ...values,
      type,
      cashInCashOutMethodId: cashInCashOutMethodId,
      bankAccountIBAN: bankAccountIBAN,
      participant,
    });

    dispatch({
      type: "REQUEST_PATCH_ADD_BORROWER_CASH_IN_CASH_OUT_METHOD",
      payload: allDataToPatch,
    });
  };

  const processPatchSetBorrowerCashInCashOutMethodToLoan = () => {
    const allDataToPatch = PatchSetBorrowerCashInCashOutMethodToLoan.dehydrate({
      id: loan.id,
      cashInCashOutMethodId: state.cashInCashOutMethodId,
    });
    dispatch({
      type: "REQUEST_PATCH_SET_BORROWER_CASH_IN_CASH_OUT_METHOD_TO_LOAN_AND_SEQUENCE",
      payload: allDataToPatch,
    });
  };

  const setItemStepOkAndSendOkMessage = () => {
    if (formSubmitSuccess) {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      dispatch({
        type: "SET_FLOW_MESSAGE",
        payload: { id: FLOW_MESSAGES.SEND_OK.id },
      });
    }
  };

  useActionCallback(
    "REQUEST_PATCH_ADD_BORROWER_CASH_IN_CASH_OUT_METHOD_FULFILLED",
    () => {
      processPatchSetBorrowerCashInCashOutMethodToLoan();
    }
  );

  useActionCallback(
    "REQUEST_PATCH_ADD_BORROWER_CASH_IN_CASH_OUT_METHOD_REJECTED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );

  useActionCallback(
    "REQUEST_PATCH_SET_BORROWER_CASH_IN_CASH_OUT_METHOD_TO_LOAN_AND_SEQUENCE_FULFILLED",
    () => {
      setState((s) => ({
        ...s,
        formSubmitSuccess: true,
      }));
    }
  );

  useEffect(() => {
    if (formSubmitSuccess) {
      setItemStepOkAndSendOkMessage();
    }
  }, [formSubmitSuccess]);

  return {
    bankAccountIBAN,
    onSubmitModule,
  };
};
